import { Action } from '@reduxjs/toolkit';
import React, { Ref, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

import { DatoInput, getDateWithCorrectTimezone } from '../../components/dato-input/dato-input';
import RouteToFremtindInfoAndModal from '../../components/route-to-fremtind-info-and-modal/route-to-fremtind-info-and-modal';
import { useKunde } from '../../kundeinfo/kunde-context';
import { updateShouldRouteKundeToFremtind } from '../../meldskade/reducer/skademelding-actions';
import { AppState } from '../../reducers';
import { SporsmalId } from '../../types/generated-types';
import { FocusableHtmlElement } from '../hooks';
import { isCurrentSporsmalValid } from '../reducer/current-steg';
import { updateDatoSvar } from '../reducer/sporsmalsflyt-actions';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentDatosporsmal } from './dato-types';

import '../../components/dato-input/dato-input.scss';

interface Props {
    currentSporsmal: CurrentDatosporsmal;
    showFeilmelding: boolean;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
}

export const Dato = ({ currentSporsmal, showFeilmelding, focusOnMount, errorRef }: Props) => {
    const dispatch = useSporsmalsflytDispatch();
    const dispatchAction: Dispatch<Action> = useDispatch();

    const { shouldRouteKundeToFremtind, routeToFremtindFeatureToggleEnabled } = useSelector(
        (state: AppState) => state.skademelding,
    );
    const [openModal, setOpenModal] = useState<boolean>(true);
    const { kundeinfo } = useKunde();

    const onChange = (dato: ZonedDate) => {
        if (dato !== undefined) {
            const dateWithCorrectTimezone = getDateWithCorrectTimezone(dato);
            dispatch(updateDatoSvar(dateWithCorrectTimezone));
            if (currentSporsmal.sporsmal.id === SporsmalId.Skadedato && routeToFremtindFeatureToggleEnabled) {
                dispatchAction(updateShouldRouteKundeToFremtind(kundeinfo.forsikringer, dato.toString()));
            }
        }
    };

    return (
        <div className="container__standard-width">
            <DatoInput
                key={`date-sporsmal-${currentSporsmal.sporsmal.id}`}
                id={`dato-sporsmal-${currentSporsmal.sporsmal.id}`}
                onChange={onChange}
                placeholder="dd.mm.åååå"
                date={currentSporsmal.dato ? getZonedDate(new Date(currentSporsmal.dato)) : undefined}
                maxDate={!currentSporsmal.sporsmal.allowFutureDate ? getZonedDate(new Date()) : undefined}
                error={showFeilmelding && !isCurrentSporsmalValid(currentSporsmal) ? 'Oppgi en gyldig dato' : undefined}
                focusOnMount={focusOnMount}
                label={currentSporsmal.sporsmal.tittel}
                sublabel={currentSporsmal.sporsmal.ingress}
                errorRef={errorRef}
            />
            {shouldRouteKundeToFremtind && (
                <RouteToFremtindInfoAndModal
                    shouldRouteKundeToFremtind={shouldRouteKundeToFremtind}
                    skadedato={currentSporsmal.dato}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                />
            )}
        </div>
    );
};
